import React from "react";
import styled from "styled-components";
import CaretClosedIcon from "@icons/Caret-Closed-Icon.svg";

const CaretIcon = styled(CaretClosedIcon)`
    stroke: ${(props) => props.theme.iconColor};
    stroke-width: 1;

    &.open {
        transform: rotate(180deg);
        transition: transform 100ms linear;
    }
    &.closed {
        transform: rotate(0deg);
        transition: transform 100ms linear;
    }
`;

interface CaretToggleIconProps {
    readonly showOpen: boolean;
    className?: string;
}
function CaretIconToggle(props: CaretToggleIconProps) {
    return <CaretIcon className={`${props.className} ${props.showOpen ? "open" : "closed"}`} />;
}
export default CaretIconToggle;
